export default __webpack_public_path__ + "static/media/home-5.5ed5f2de.jpg";